export default __webpack_public_path__ + "static/clubTercera_BG-695ffd58ce8a2925df098fe935d1a451.jpg";